// extracted by mini-css-extract-plugin
module.exports = {"componentsBankCardForm":"styles_componentsBankCardForm__17-nm","noticeBar":"styles_noticeBar__33i1e"};